const API_URL = process.env.REACT_APP_API_URL;
// const API_URL = "http://192.168.0.100:8000/nrm_dk";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
// const IMAGE_URL = "http://192.168.0.100:8000/nrm_dk/media_dk/CaseFiles";


 const IMAGE_URL2 = process.env.REACT_APP_IMAGE_URL2;
const security_key = process.env.REACT_APP_API_KEY;

export { API_URL, BASE_URL, IMAGE_URL, security_key ,IMAGE_URL2};
